// Profile timeline wording for the sales agent's events (actionClass salesAgent).
const LABELS = {
  agentSessionStart: 'Entered a sales agent session',
  agentCardClick: 'Opened a product from the sales agent',
  agentAction: 'Used a sales agent button',
  agentLocation: 'Shared location with the sales agent',
  agentFeedback: 'Rated an answer',
};

// Only outcomes known to be failures override the label; anything else stays neutral.
const UNAVAILABLE_OUTCOMES = new Set(['unavailable', 'timeout', 'error']);

const VOTES = { 1: '👍', '-1': '👎', 0: 'removed' };

/** The timeline label of a sales agent event, or null for any other event. */
export const salesAgentEventLabel = (event) => {
  if (event.action === 'agentLocation') {
    if (event.data?.outcome === 'denied') return 'Declined to share location';
    if (UNAVAILABLE_OUTCOMES.has(event.data?.outcome)) return 'Location not available';
  }
  return LABELS[event.action] ?? null;
};

/** One-line details of a sales agent event: the button and its outcome, or the vote. */
export const salesAgentEventDetail = (event) => {
  const data = event.data || {};
  if (event.action === 'agentFeedback') return VOTES[data.value] ? `Vote: ${VOTES[data.value]}` : null;
  return [data.type, data.source && `from ${data.source}`, data.outcome].filter(Boolean).join(' · ') || null;
};
